import { createSelector } from '@reduxjs/toolkit';

import { B2BClientsState, name } from '../reducers/b2bClients';

export const getB2BClientsSlice = (state): B2BClientsState => state[name];

export const b2bClientsSelector = createSelector(
  [getB2BClientsSlice],
  ({ clients }) => clients
);

export const b2bClientsFiltersSelector = createSelector(
  [getB2BClientsSlice],
  ({ filters }) => filters
);

export const b2bClientsMetaSelector = createSelector(
  [getB2BClientsSlice],
  ({ meta }) => meta
);

export const b2bClientsErrorSelector = createSelector(
  [getB2BClientsSlice],
  ({ error }) => error
);

export const activeB2BClientIdSelector = createSelector(
  [getB2BClientsSlice],
  ({ activeClientId }) => activeClientId
);

export const activeB2BClientSelector = createSelector(
  [getB2BClientsSlice],
  ({ activeClient }) => activeClient
);

export const filteredB2BClientsSelector = createSelector(
  [b2bClientsSelector],
  (clients) => clients
);

export const isB2BClientsLoadingSelector = createSelector(
  [getB2BClientsSlice],
  ({ isLoading }) => isLoading
);

export const isB2BActiveClientLoadingSelector = createSelector(
  [getB2BClientsSlice],
  ({ isLoadingActiveClient }) => isLoadingActiveClient
);

export const isB2BClientSavingSelector = createSelector(
  [getB2BClientsSlice],
  ({ isSaving }) => isSaving
);
